<template>
    <div class="info-familiar">
        <div class="info-familiar__toolbar">

            <v-btn class="info-familiar__primary" :disabled="!personaIdValida" @click="nuevo">
                <v-icon left>mdi-plus</v-icon>
                Agregar familiar
            </v-btn>
        </div>

        <v-data-table :headers="headers" :items="familiares" :loading="loading" item-key="oid" class="historial-table info-familiar__table"
            :footer-props="{ 'items-per-page-options': [5, 10, 20, 50] }" no-data-text="No hay información familiar.">
            <template v-slot:item.index="{ index }">
                {{ index + 1 }}
            </template>

            <template v-slot:item.nombreCompleto="{ item }">
                <div class="info-familiar__strong">{{ nombreCompleto(item) }}</div>
                <div class="info-familiar__muted">{{ nombreCatalogo('TipoDocumento', item.oid_tipo_documento) }} {{ item.documento || '' }}</div>
            </template>

            <template v-slot:item.fecha_nacimiento="{ item }">
                {{ formatoFecha(item.fecha_nacimiento) }}
            </template>

            <template v-slot:item.oid_parentesco="{ item }">
                {{ nombreCatalogo('Parentesco', item.oid_parentesco) }}
            </template>

            <template v-slot:item.oid_genero="{ item }">
                {{ nombreCatalogo('Genero', item.oid_genero) }}
            </template>

            <template v-slot:item.ubicacion="{ item }">
                {{ ubicacionTexto(item) }}
            </template>

            <template v-slot:item.actions="{ item }">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-icon small v-on="on" @click="mostrar(item.oid)">mdi-eye</v-icon>
                    </template>
                    <span>Detalle</span>
                </v-tooltip>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-icon small v-on="on" @click="editar(item)">mdi-pencil</v-icon>
                    </template>
                    <span>Editar</span>
                </v-tooltip>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-icon small color="error" v-on="on" @click="confirmarEliminar(item)">mdi-delete</v-icon>
                    </template>
                    <span>Eliminar</span>
                </v-tooltip>
            </template>
        </v-data-table>

        <v-dialog v-model="dialogForm" max-width="85%" persistent scrollable>
            <v-card class="perfil-dialog-card">
                <v-card-title class="perfil-dialog-title">
                    <span>{{ formTitle }}</span>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="cerrarForm" :disabled="guardando">
                        <v-icon color="#384018">mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="perfil-dialog-body">
                    <v-form ref="form" v-model="formValid" lazy-validation>
                        <v-container fluid>
                            <v-row>
                                <v-col cols="12">
                                    <div class="form-section-title">Información General</div>
                                </v-col>

                                <v-col cols="12" md="4">
                                    <v-text-field v-model="form.nombres" :rules="[rules.required]" label="Nombres" outlined dense clearable class="perfil-field" />
                                </v-col>

                                <v-col cols="12" md="4">
                                    <v-text-field v-model="form.primero_apellido" :rules="[rules.required]" label="Primer apellido" outlined dense clearable class="perfil-field" />
                                </v-col>

                                <v-col cols="12" md="4">
                                    <v-text-field v-model="form.segundo_apellido" label="Segundo apellido" outlined dense clearable class="perfil-field" />
                                </v-col>

                                <v-col cols="12" md="3">
                                    <v-select v-model="form.oid_tipo_documento" :items="Catalogo.TipoDocumento" item-text="nombre" item-value="oid" :rules="[rules.required]" label="Tipo documento" outlined dense clearable class="perfil-field" />
                                </v-col>

                                <v-col cols="12" md="3">
                                    <v-text-field v-model="form.documento" :rules="[rules.required]" label="Documento" outlined dense clearable class="perfil-field" />
                                </v-col>

                                <v-col cols="12" md="3">
                                    <v-select v-model="form.oid_genero" :items="Catalogo.Genero" item-text="nombre" item-value="oid" :rules="[rules.required]" label="Género" outlined dense clearable class="perfil-field" />
                                </v-col>

                                <v-col cols="12" md="3">
                                    <v-text-field v-model="form.fecha_nacimiento" label="Fecha nacimiento" type="date" outlined dense clearable class="perfil-field" />
                                </v-col>

                                <v-col cols="12" class="mt-2">
                                    <div class="form-section-title">Parentesco y Contacto</div>
                                </v-col>

                                <v-col cols="12" md="4">
                                    <v-select v-model="form.oid_parentesco" :items="Catalogo.Parentesco" item-text="nombre" item-value="oid" :rules="[rules.required]" label="Parentesco" outlined dense clearable class="perfil-field" />
                                </v-col>

                                <v-col cols="12" md="4">
                                    <v-text-field v-model="form.telefono" label="Teléfono" outlined dense clearable class="perfil-field" />
                                </v-col>

                                <v-col cols="12" md="4">
                                    <v-text-field v-model="form.direccion" label="Dirección" outlined dense clearable class="perfil-field" />
                                </v-col>

                                <v-col cols="12" class="mt-2">
                                    <div class="form-section-title">Ubicación</div>
                                </v-col>

                                <v-col cols="12" md="4">
                                    <v-select v-model="form.oid_pais" :items="LPais" item-text="nombre" item-value="oid" label="País" outlined dense clearable class="perfil-field" />
                                </v-col>

                                <v-col cols="12" md="4">
                                    <v-select v-model="form.oid_depto" :items="deptoFiltrado" item-text="nombre" item-value="oid" label="Departamento" outlined dense clearable class="perfil-field" />
                                </v-col>

                                <v-col cols="12" md="4">
                                    <v-select v-model="form.oid_ciudad" :items="ciudadFiltrada" item-text="nombre" item-value="oid" label="Ciudad" outlined dense clearable class="perfil-field" />
                                </v-col>

                                <v-col cols="12">
                                    <v-textarea v-model="form.observacion" label="Observación" outlined dense rows="2" auto-grow clearable class="perfil-field" />
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-card-text>

                <v-card-actions class="perfil-dialog-actions">
                    <v-spacer></v-spacer>
                    <v-btn text color="#5e672c" @click="cerrarForm" :disabled="guardando">
                        Cancelar
                    </v-btn>
                    <v-btn class="perfil-btn-primary" :loading="guardando" :disabled="!formValid || guardando" @click="guardar">
                        {{ editando ? 'Actualizar' : 'Guardar' }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogEliminar" max-width="420px">
            <v-card>
                <v-card-title class="headline">Confirmar eliminación</v-card-title>
                <v-card-text>
                    ¿Deseas eliminar el registro familiar de
                    <b>{{ itemEliminar ? nombreCompleto(itemEliminar) : '' }}</b>?
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="#5e672c" @click="dialogEliminar = false">Cancelar</v-btn>
                    <v-btn color="error" text :loading="eliminando" @click="eliminar">Eliminar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- Diálogo detalle familiar -->
        <v-dialog v-model="dialogdetail" max-width="75%">
            <v-card class="perfil-dialog-card">
                
                <v-card-title class="perfil-dialog-title">
                    <span>{{ formTitle }}</span>

                    <v-spacer></v-spacer>

                    <v-btn icon @click="dialogdetail = false">
                        <v-icon color="#384018">mdi-close</v-icon>
                    </v-btn>
                </v-card-title>

                <v-card-text class="perfil-dialog-body">
                    <v-container fluid>
                        
                        <!-- INFORMACIÓN GENERAL -->
                        <v-row>
                            <v-col cols="12">
                                <div class="form-section-title">
                                    Información General
                                </div>
                            </v-col>

                            <v-col cols="12" md="4">
                                <strong>Nombres:</strong><br>
                                {{ dato.nombres || 'Sin dato' }}
                            </v-col>

                            <v-col cols="12" md="4">
                                <strong>Primer apellido:</strong><br>
                                {{ dato.primero_apellido || 'Sin dato' }}
                            </v-col>

                            <v-col cols="12" md="4">
                                <strong>Segundo apellido:</strong><br>
                                {{ dato.segundo_apellido || 'Sin dato' }}
                            </v-col>

                            <v-col cols="12" md="3">
                                <strong>Tipo documento:</strong><br>
                                {{ nombreCatalogo('TipoDocumento', dato.oid_tipo_documento) }}
                            </v-col>

                            <v-col cols="12" md="3">
                                <strong>Documento:</strong><br>
                                {{ dato.documento || 'Sin dato' }}
                            </v-col>

                            <v-col cols="12" md="3">
                                <strong>Género:</strong><br>
                                {{ nombreCatalogo('Genero', dato.oid_genero) }}
                            </v-col>

                            <v-col cols="12" md="3">
                                <strong>Fecha nacimiento:</strong><br>
                                {{ formatoFecha(dato.fecha_nacimiento) }}
                            </v-col>
                        </v-row>

                        <!-- PARENTESCO -->
                        <v-row>
                            <v-col cols="12">
                                <div class="form-section-title">
                                    Parentesco y Contacto
                                </div>
                            </v-col>

                            <v-col cols="12" md="4">
                                <strong>Parentesco:</strong><br>
                                {{ nombreCatalogo('Parentesco', dato.oid_parentesco) }}
                            </v-col>

                            <v-col cols="12" md="4">
                                <strong>Teléfono:</strong><br>
                                {{ dato.telefono || 'Sin dato' }}
                            </v-col>

                            <v-col cols="12" md="4">
                                <strong>Dirección:</strong><br>
                                {{ dato.direccion || 'Sin dato' }}
                            </v-col>
                        </v-row>

                        <!-- UBICACIÓN -->
                        <v-row>
                            <v-col cols="12">
                                <div class="form-section-title">
                                    Ubicación
                                </div>
                            </v-col>

                            <v-col cols="12" md="4">
                                <strong>País:</strong><br>
                                {{ getPaisN(dato.oid_pais) }}
                            </v-col>

                            <v-col cols="12" md="4">
                                <strong>Departamento:</strong><br>
                                {{ getDeptoN(dato.oid_depto) }}
                            </v-col>

                            <v-col cols="12" md="4">
                                <strong>Ciudad:</strong><br>
                                {{ getCiudadN(dato.oid_ciudad) }}
                            </v-col>
                        </v-row>

                        <!-- AUDITORÍA -->
                        <v-row>
                            <v-col cols="12">
                                <div class="form-section-title">
                                    Auditoría
                                </div>
                            </v-col>

                            <v-col cols="12" md="3">
                                <strong>Fecha registro:</strong><br>
                                {{ dato.fecha ? new Date(dato.fecha).toLocaleString() : 'Sin dato' }}
                            </v-col>

                            <v-col cols="12" md="3">
                                <strong>Usuario registro:</strong><br>
                                {{ getUserN(dato.oid_user) }}
                            </v-col>

                            <v-col cols="12"  md="6">
                                <div class="pa-4 detalle-box">
                                    {{ dato.observacion || 'Sin observaciones registradas' }}
                                </div>
                            </v-col>
                        </v-row>

                    </v-container>
                </v-card-text>

                <v-card-actions class="perfil-dialog-actions">
                    <v-spacer></v-spacer>

                    <v-btn
                        text
                        color="#5e672c"
                        @click="dialogdetail = false"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>

            </v-card>
        </v-dialog>

        <v-snackbar v-model="snackbar" :color="snackbarColor" timeout="3500" top>
            {{ snackbarMensaje }}
            <template v-slot:action="{ attrs }">
                <v-btn text v-bind="attrs" @click="snackbar = false">Cerrar</v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
import axios from 'axios';
import { setUsers, getUserN } from '@/utils/validators';
import {
    loadAll,
    getOptionsByCodigo,
    setDatos,
    getPaises,
    getDeptos,
    getCiudades,
    getPaisN,
    getDeptoN,
    getCiudadN,
} from '@/utils/catalogo';

const formBase = () => ({
    oid: 0,
    oid_persona: null,
    nombres: '',
    primero_apellido: '',
    segundo_apellido: '',
    oid_tipo_documento: null,
    documento: '',
    oid_genero: null,
    fecha_nacimiento: null,
    oid_parentesco: null,
    direccion: '',
    oid_pais: null,
    oid_depto: null,
    oid_ciudad: null,
    telefono: '',
    observacion: '',
    oid_user: null,
    fecha: null,
});

export default {
    name: 'InfoFamiliar',
    props: {
        personaId: { type: Number, default: null },
        userOid: { type: Number, default: null },
    },
    data() {
        return {
            dato: {},
            familiares: [],
            loading: false,
            guardando: false,
            eliminando: false,
            dialogForm: false,
            dialogEliminar: false,
            formValid: false,
            editando: false,
            form: formBase(),
            itemEliminar: null,
            LPais: [],
            LDepto: [],
            LCiudad: [],
            Catalogo: {
                TipoDocumento: [],
                Genero: [],
                Parentesco: [],
            },
            snackbar: false,
            snackbarMensaje: '',
            snackbarColor: 'success',
            rules: {
                required: value => value !== null && value !== undefined && value !== '' || 'Requerido',
            },
            headers: [
                { text: 'Acciones', value: 'actions', sortable: false, align: 'center', width: 110 },
                { text: '#', value: 'index', sortable: false, width: 60 },
                { text: 'Familiar', value: 'nombreCompleto' },
                { text: 'Género', value: 'oid_genero' },
                { text: 'Fecha nacimiento', value: 'fecha_nacimiento' },
                { text: 'Parentesco', value: 'oid_parentesco' },
                { text: 'Teléfono', value: 'telefono' },
                { text: 'Ubicación', value: 'ubicacion' },
            ],
            formTitle: '', // Título del diálogo
            dialogdetail: false,
        };
    },
    computed: {
        personaIdValida() {
            return Number(this.personaId) > 0;
        },
        usuarioActual() {
            return this.userOid || Number(localStorage.getItem('oidu')) || null;
        },
        deptoFiltrado() {
            if (!this.form.oid_pais) return [];
            return this.LDepto.filter(item => Number(item.oid_pais) === Number(this.form.oid_pais));
        },
        ciudadFiltrada() {
            if (!this.form.oid_depto) return [];
            return this.LCiudad.filter(item => Number(item.oid_depto) === Number(this.form.oid_depto));
        },
        catMap() {
            const toMap = arr => (arr || []).reduce((acc, item) => {
                acc[item.oid] = item.nombre;
                return acc;
            }, {});

            return {
                TipoDocumento: toMap(this.Catalogo.TipoDocumento),
                Genero: toMap(this.Catalogo.Genero),
                Parentesco: toMap(this.Catalogo.Parentesco),
            };
        },
    },
    watch: {
        personaId: {
            immediate: true,
            handler() {
                this.listar();
            },
        },
        'form.oid_pais'(value, oldValue) {
            if (value !== oldValue && !this.editando) {
                this.form.oid_depto = null;
                this.form.oid_ciudad = null;
            }
        },
        'form.oid_depto'(value, oldValue) {
            if (value !== oldValue && !this.editando) {
                this.form.oid_ciudad = null;
            }
        },
    },
    async mounted() {
        await this.cargarCatalogos();
        await this.listar();
        await setUsers();
    },
    methods: {
        async cargarCatalogos() {
            try {
                await Promise.all([loadAll(), setDatos()]);
                this.Catalogo.TipoDocumento = getOptionsByCodigo('TipoDocumento');
                this.Catalogo.Genero = getOptionsByCodigo('Genero');
                this.Catalogo.Parentesco = getOptionsByCodigo('Parentesco');
                this.LPais = getPaises();
                this.LDepto = getDeptos();
                this.LCiudad = getCiudades();
            } catch (error) {
                console.error(error);
                this.notificar('Error al cargar catálogos familiares', 'error');
            }
        },
        async listar() {
            if (!this.personaIdValida) {
                this.familiares = [];
                return;
            }

            this.loading = true;
            try {
                const response = await axios.get(`api/PersonaInfoFamiliars/MostrarPorPersona/${this.personaId}`);
                this.familiares = Array.isArray(response.data) ? response.data : [];
            } catch (error) {
                console.error(error);
                this.familiares = [];
                this.notificar('Error al cargar información familiar', 'error');
            } finally {
                this.loading = false;
            }
        },
        nuevo() {
            this.editando = false;
            this.form = {
                ...formBase(),
                oid_persona: this.personaId,
                oid_user: this.usuarioActual,
                fecha: new Date().toISOString(),
            };
            this.formTitle = 'Registrar Familiar';
            this.dialogForm = true;
            this.$nextTick(() => {
                this.$refs.form && this.$refs.form.resetValidation();
            });
        },
        async editar(item) {
            this.formTitle = 'Actualizar Familiar';
            this.editando = true;
            try {
                const response = await axios.get(`api/PersonaInfoFamiliars/Mostrar/${item.oid}`);
                const data = response.data || item;
                this.form = {
                    ...formBase(),
                    ...data,
                    oid_persona: data.oid_persona || this.personaId,
                    fecha_nacimiento: data.fecha_nacimiento ? String(data.fecha_nacimiento).substring(0, 10) : null,
                    oid_user: data.oid_user || this.usuarioActual,
                    fecha: data.fecha || new Date().toISOString(),
                };
                this.dialogForm = true;
                this.$nextTick(() => {
                    this.$refs.form && this.$refs.form.resetValidation();
                });
            } catch (error) {
                console.error(error);
                this.notificar('Error al consultar el familiar', 'error');
            }
        },
        // Mostrar detalles
        async mostrar(id) {
            this.formTitle = 'Detalle Familiar';

            try {
                const response = await axios.get(`api/PersonaInfoFamiliars/Mostrar/${id}`);

                this.dato = response.data || {};
                this.dialogdetail = true;

            } catch (error) {
                console.error(error);
                this.notificar('Error al consultar el detalle del familiar', 'error');
            }
        },
        cerrarForm() {
            if (this.guardando) return;
            this.dialogForm = false;
            this.form = formBase();
            this.formValid = false;
            this.editando = false;
        },
        async guardar() {
            const ok = this.$refs.form && this.$refs.form.validate();
            if (!ok || !this.personaIdValida) return;

            this.guardando = true;
            try {
                const payload = {
                    ...this.form,
                    oid_persona: this.personaId,
                    oid_user: this.usuarioActual,
                    fecha: this.form.fecha || new Date().toISOString(),
                };

                if (this.editando) {
                    await axios.put('api/PersonaInfoFamiliars/Actualizar', payload);
                    this.notificar('Información familiar actualizada correctamente', 'success');
                } else {
                    await axios.post('api/PersonaInfoFamiliars/Crear', payload);
                    this.notificar('Información familiar registrada correctamente', 'success');
                }

                this.cerrarForm();
                this.dialogForm = false;
                await this.listar();
                this.$emit('updated');
            } catch (error) {
                console.error(error);
                this.notificar('Error al guardar información familiar', 'error');
            } finally {
                this.guardando = false;
            }
        },
        confirmarEliminar(item) {
            this.itemEliminar = item;
            this.dialogEliminar = true;
        },
        async eliminar() {
            if (!this.itemEliminar) return;

            this.eliminando = true;
            try {
                await axios.delete(`api/PersonaInfoFamiliars/Eliminar/${this.itemEliminar.oid}`);
                this.notificar('Información familiar eliminada correctamente', 'success');
                this.dialogEliminar = false;
                this.itemEliminar = null;
                await this.listar();
                this.$emit('updated');
            } catch (error) {
                console.error(error);
                this.notificar('Error al eliminar información familiar', 'error');
            } finally {
                this.eliminando = false;
            }
        },
        nombreCompleto(item) {
            return [
                item.nombres,
                item.primero_apellido,
                item.segundo_apellido,
            ].filter(Boolean).join(' ') || 'Sin nombre';
        },
        nombreCatalogo(catalogo, oid) {
            return this.catMap[catalogo]?.[oid] || 'Sin dato';
        },
        ubicacionTexto(item) {
            const partes = [
                item.oid_ciudad ? getCiudadN(item.oid_ciudad) : null,
                item.oid_depto ? getDeptoN(item.oid_depto) : null,
                item.oid_pais ? getPaisN(item.oid_pais) : null,
            ].filter(Boolean).filter(value => value !== 'Desconocido');

            return partes.length ? partes.join(', ') : 'Sin dato';
        },
        formatoFecha(fecha) {
            if (!fecha) return 'Sin dato';
            return String(fecha).substring(0, 10);
        },
        notificar(mensaje, color = 'success') {
            this.snackbarMensaje = mensaje;
            this.snackbarColor = color;
            this.snackbar = true;
        },
        getPaisN, getDeptoN, getCiudadN, getUserN,
    },
};
</script>

<style scoped>
.info-familiar {
    width: 100%;
}

.info-familiar__toolbar {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    margin-bottom: 18px;
}

.info-familiar__primary {
    background: #5e672c !important;
    color: #ffffff !important;
    border-radius: 12px !important;
    font-weight: 800 !important;
    text-transform: none !important;
    box-shadow: 0 8px 18px rgba(56, 61, 24, 0.22) !important;
}

.info-familiar__table {
    border: 1px solid rgba(108, 117, 51, 0.14);
    border-radius: 14px;
    overflow: hidden;
}

.info-familiar__strong {
    color: #303641;
    font-weight: 800;
}

.info-familiar__muted {
    color: #6b7280;
    font-size: 12px;
    font-weight: 600;
}

/* MISMO ESTILO DEL FORMULARIO FUNCIONARIO */
.perfil-dialog-card {
    background: #fbfcfa !important;
    border: 1px solid rgba(108, 117, 51, 0.16) !important;
    border-radius: 20px !important;
    overflow: hidden !important;
    box-shadow: 0 16px 42px rgba(56, 61, 24, 0.22) !important;
}

.perfil-dialog-title {
    background: linear-gradient(135deg, #e6e9de 0%, #dfe4d2 100%) !important;
    border-bottom: 1px solid rgba(108, 117, 51, 0.15) !important;
    color: #384018 !important;
    font-size: 22px !important;
    font-weight: 800 !important;
    padding: 18px 24px !important;
    text-align: center;
}

.perfil-dialog-body {
    background: linear-gradient(180deg, #f8f9f6 0%, #eef0ea 100%) !important;
    padding: 24px !important;
}

.form-section-title {
    width: 100%;
    text-align: center;
    color: #384018 !important;
    font-size: 18px !important;
    font-weight: 800 !important;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    margin: 14px 0 16px 0;
    border-bottom: 1px solid rgba(108, 117, 51, 0.18);
    background: rgba(255, 255, 255, 0.6);
    border-radius: 12px;
    padding: 10px 16px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
}

.form-section-title::before {
    content: "●";
    color: #f7c325;
    font-size: 14px;
    margin-right: 10px;
}

/* Campos */
.perfil-field ::v-deep .v-input__slot {
    background: linear-gradient(180deg, #f9faf8 0%, #eef0eb 100%) !important;
    border-radius: 14px !important;
    box-shadow: inset 0 1px 2px rgba(0,0,0,0.04);
}

.perfil-field ::v-deep .v-input__slot fieldset {
    border-color: rgba(108, 117, 51, 0.14) !important;
    border-left: 4px solid #c9a538 !important;
}

.perfil-field:hover ::v-deep .v-input__slot fieldset {
    border-color: rgba(201, 165, 56, 0.65) !important;
}

.perfil-field.v-input--is-focused ::v-deep .v-input__slot fieldset {
    border-color: #c9a538 !important;
    border-width: 1px !important;
    border-left-width: 4px !important;
}

.perfil-field ::v-deep .v-label {
    color: #727b4a !important;
    font-size: 15px !important;
    font-weight: 800 !important;
}

.perfil-field ::v-deep input,
.perfil-field ::v-deep textarea {
    color: #303641 !important;
    font-weight: 700 !important;
}

.perfil-field ::v-deep .v-select__selection {
    color: #303641 !important;
    font-weight: 700 !important;
}

.perfil-field ::v-deep .v-icon {
    color: #e4b510 !important;
}

.perfil-field.v-input--is-focused ::v-deep .v-label {
    color: #5e672c !important;
}

/* Acciones */
.perfil-dialog-actions {
    background: #fbfcfa !important;
    border-top: 1px solid rgba(108, 117, 51, 0.12);
    padding: 16px 24px 22px 24px;
}

.perfil-dialog-actions .v-btn--text {
    color: #5e672c !important;
    font-weight: 800 !important;
}

.perfil-btn-primary {
    color: white !important;
    background-color: #5e672c !important;
    border-radius: 12px !important;
    font-size: 14px !important;
    font-weight: 800 !important;
    letter-spacing: 0.3px;
    text-transform: none !important;
    padding: 0 20px !important;
    box-shadow: 0 8px 18px rgba(56, 61, 24, 0.22) !important;
}

.perfil-btn-primary:hover {
    filter: brightness(1.08);
}

@media (max-width: 700px) {
    .info-familiar__toolbar {
        align-items: stretch;
        flex-direction: column;
    }

    .perfil-dialog-body {
        padding: 16px !important;
    }

    .perfil-dialog-title {
        font-size: 18px !important;
        padding: 14px 18px !important;
    }
    .detalle-box {
        background: rgba(255,255,255,0.7);
        border-radius: 12px;
        border: 1px solid rgba(108, 117, 51, 0.14);
        color: #303641;
        font-weight: 600;
        min-height: 80px;
    }
}
</style>